import { useDispatch } from 'react-redux'
import { GETVehiclesResponse, IVehicleType } from '@cbgms/api/modules/vehicles'
import { IGroup } from '@cbgms/base/utils/helpers'
import { EmptyUUID } from '@cbgms/base/utils/uuid'
import { useShowVehicleTypeSelector } from 'app/vehicles/components/SelectVehicleType/use-select-vehicle-type'
import { ResultObjectType, VehicleProvider } from '@cbgms/api'
import { createVehicle, getVehiclesByVin, setLoadedVehicle, updateVehicle } from 'app/vehicles/state/actions'
import { useShowDuplicateVinSelector } from 'app/vehicles/components/DuplicateVehicleFound/DuplicateVinContext'
import { useHistory } from 'react-router-dom'

export const useOpenVehicle = () => {
  const navigation = useHistory()
  const { showSelection } = useShowVehicleTypeSelector()
  const { showSelection: showVinSelection } = useShowDuplicateVinSelector()
  const dispatch = useDispatch()

  return async (Vehicle: IGroup<IVehicleType>, Type: ResultObjectType) => {
    const source = (Vehicle.Values?.find(v => v?.GenericVehicle?.Source)?.GenericVehicle?.Source || '') as VehicleProvider
    const genericVehicleOptions = Vehicle.Values.map(v => v.GenericVehicle)
    const genericVehicle = await showSelection(genericVehicleOptions, source)
    const vehicleItem = Vehicle.Values.find(v => v.GenericVehicle.ID === genericVehicle.ID)

    if (Type === ResultObjectType.DatabaseVehicle) {
      navigation.push(`/vehicles/${vehicleItem?.UUID}`)
    } else if (vehicleItem) {
      // Create vehicle if it is not in our database yet
      let vehicleUUID = vehicleItem.UUID
      if (Vehicle.Values[0].Registration === '') {
        dispatch(setLoadedVehicle(vehicleItem))
        navigation.push('/vehicles/quick-create', vehicleItem)
        return
      } else if (vehicleUUID === EmptyUUID) {
        // Check if there are vehicles with this VIN ( and length 17)
        if (vehicleItem.Vin && vehicleItem.Vin.length === 17) {
          try {
            const vehicleWithDuplicateVin = ((await dispatch(getVehiclesByVin(vehicleItem.Vin))) as any as GETVehiclesResponse).Data
            if (vehicleWithDuplicateVin.length) {
              await showVinSelection(vehicleItem, vehicleWithDuplicateVin[0].Vehicle)
              await dispatch(updateVehicle(vehicleWithDuplicateVin[0].Vehicle.UUID, { Vin: '' }))
            }
          } catch {
            return
          }
        }
        const { Data } = await dispatch(createVehicle(vehicleItem))

        vehicleUUID = Data.UUID
      }

      navigation.push(`/vehicles/${vehicleUUID}`)
    }
  }
}
